import { getAdvisorProfile } from 'src/services/advisor';
import { useQuery } from 'react-query';
import { queryPresets } from './base';
import {  ACCOUNT_ROLE_ID, useReactQuery } from 'src/queries/useQuery';
import { GQLAdvisorAccountByUserName } from 'src/services/grapqlQueries/advisorProfiles';
export const queryKey = 'advisor-profiles';

/**
 useAdvisorProfilesQuery is used to pull advisor profile of
 current authenticated user's advisor profile
*/
export const useAdvisorProfilesQuery = (accountId:any,enabled: boolean = true) => {
  return useQuery<any, any>([queryKey], () => getAdvisorProfile(accountId), {
    ...queryPresets.longLived,
    enabled,
    retry: true,
  });
};


export const getAccountRoleByUserName = (
  variables: any,
  enabled: boolean = true
) => {
  return useReactQuery(
    [ACCOUNT_ROLE_ID, variables],
    () => GQLAdvisorAccountByUserName(variables),
    {
    ...queryPresets.oneTimeFetch,
    enabled,
    retry: true,
  });
};
